import FacilityRowComponent from './facility-row-component';

/***
 * The static representation of a single facility
 */
const FacilityRow = angular
    .module('FacilityData.ClientAdmin.FacilityRow', [])
    .component('facilityRow', FacilityRowComponent)
    .name;

export default FacilityRow;



// WEBPACK FOOTER //
// ./app/components/client-admin/facility-row/facility-row.js